var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
// DO NOT REMOVE `configBehaviorIgnore: true` - this is a test file
const _require = require(/* configBehaviorIgnore: true */'../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const _transientContext$sel = transientContext.selection,
    selection = _transientContext$sel === void 0 ? {} : _transientContext$sel;
  const _Object$keys = Object.keys(selection),
    _Object$keys2 = _slicedToArray(_Object$keys, 1),
    firstKey = _Object$keys2[0];
  const _ref = selection[firstKey] || {},
    _ref$title = _ref.title,
    message = _ref$title === void 0 ? 'No option' : _ref$title;
  const alertSource = {
    type: 'alertBehavior',
    title: 'Config Options',
    message,
    options: [{
      title: 'OK'
    }]
  };
  const result = await evaluateSource(alertSource, content, parentContentPath, transientContext, nativeFunctions);
  return result;
};
module.exports = {
  evaluate
};